module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-left.db239ba3.svg";